var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'option': true, 'mobile': _vm.mobile}},[_c('input',{attrs:{"type":"text","spellcheck":"false","maxlength":"80"},domProps:{"value":_vm.title},on:{"change":_vm.onChange}})])}
var staticRenderFns = []

export { render, staticRenderFns }